export default __webpack_public_path__ + "static/divider2Svg-121afb6665b5a59e5941af833cb096f1.svg";